import { apiGet } from './client';
import type { ServerRecord } from './types';

export async function fetchServers() {
  const data = await apiGet<{ servers: ServerRecord[] }>('/servers');
  return data.servers;
}
